module.exports = __webpack_public_path__ + "img/instagram.f6169629.png";